import * as successAction from "../actionTypes/successActionTypes"

export interface SuccessState {
  emailId: string;
  transactionStatus: string;
  validVintage: string;
  arcError:any;
}

const initialState: SuccessState = {
  emailId: "",
  transactionStatus: "",
  validVintage : "",
  arcError: false,
}

export const SuccessReducer = (
  state: SuccessState = initialState,
  action: successAction.SuccessActions
): SuccessState => {
  switch (action.type) {
    case successAction.SUBMIT_ARC_APPROVE_SUCCESS:
      return {
        ...state,
        emailId: action.response.emailId,
        validVintage: action.response.validVintage,
        transactionStatus: action.response.transactionStatus,
      };

      case successAction.SUBMIT_ARC_APPROVE_FAILURE:
      return {
        ...state,
        arcError: true
      };
      
    default:
      return state
  }
}